import { createFileRoute } from '@tanstack/react-router'
import { BundleStackingEditor } from './-BundleStackingEditor'

export const Route = createFileRoute('/settings/packaging/bundle-stackings/$id')({
  component: EditBundleStackingPage,
})

function EditBundleStackingPage() {
  const { id } = Route.useParams()
  return <BundleStackingEditor id={id} />
}
